/*
 * <bw-sources> (snippets/bw-sources.liquid; owner rule 2026-10-13, CLAUDE.md §5)
 * Each entry in the bottom Sources list ends with a ↩︎ link back to the first
 * marker that cites it. On the FAQ pages that marker sits inside an accordion
 * <details>, which may be closed. Open it before the jump so the link lands on
 * visible text. Chromium opens it on its own; this covers other browsers.
 * Without JS the link still scrolls to the closed question.
 */
class BwSources extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const link = event.target.closest('a.bw-sources__back');
      if (!link) return;
      const id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      let closed = target.closest('details:not([open])');
      while (closed) {
        closed.open = true;
        closed = closed.parentElement ? closed.parentElement.closest('details:not([open])') : null;
      }
    });
  }
}

if (!customElements.get('bw-sources')) {
  customElements.define('bw-sources', BwSources);
}
